import type { Incident, IncidentBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Incident, IncidentBase>({
  tableName: "incidents",
  viewName: "incidents_enriched",
  searchColumns: ["title"],
  computedColumns: ["locationName", "assetName", "reportedByName", "assigneeName"],
});

export class IncidentService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
